import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    fill="currentColor"
    viewBox="0 0 10 10"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 5a2.31 2.31 0 0 1-1.7-.7 2.31 2.31 0 0 1-.7-1.7q0-1 .7-1.7A2.31 2.31 0 0 1 5 .2q1 0 1.7.7t.7 1.7-.7 1.7T5 5M.2 8.6v-.4q0-.383.208-.725.209-.342.575-.575a8.2 8.2 0 0 1 1.938-.817 7.73 7.73 0 0 1 4.154 0q1.024.284 1.942.817.366.216.575.567.208.35.208.733v.4q0 .495-.353.848A1.16 1.16 0 0 1 8.6 9.8H1.395Q.9 9.8.55 9.448A1.16 1.16 0 0 1 .2 8.6m1.2 0h7.2v-.4a.26.26 0 0 0-.05-.157.34.34 0 0 0-.133-.11 6.3 6.3 0 0 0-1.634-.7A6.8 6.8 0 0 0 5 7a6.8 6.8 0 0 0-1.783.233 6.3 6.3 0 0 0-1.634.7 1 1 0 0 0-.133.13.22.22 0 0 0-.05.137zm3.603-4.8q.497 0 .847-.354.35-.353.35-.85 0-.496-.354-.846a1.17 1.17 0 0 0-.85-.35q-.496 0-.846.354-.35.353-.35.85 0 .496.353.846.354.35.85.35"
    />
  </svg>
);
export default SvgPerson;
